module.exports = __webpack_public_path__ + "ec0810ff10c53205bb3e8503d6738c0b.MP3";